export const MAIN_CHECKIN_TEST_IDS = {
  // ─── Check-in Tab Container ───
  tabContainer: 'main-checkin-tab-container',
  heading: 'main-checkin-heading',
  subheading: 'main-checkin-subheading',
  image: 'main-checkin-image',

  // ─── Check-in Form ───
  form: 'main-checkin-form',
  emailOrLastNameInput: 'main-checkin-email-lastname-input',
  recordLocatorInput: 'main-checkin-record-locator-input',
  errorMessage: 'main-checkin-error-message',
  captchaErrorMessage: 'main-checkin-captcha-error',
  continueButton: 'main-checkin-continue-btn',
} as const;
